import Lang from 'lang.js';

import messages from './../messages';

const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;

let trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );

export default {
    methods: {
        __(key) {
            if (default_locale === 'en') {
                return key;
            }
            return trans.get('strings.'+key);
        },

    }
};